import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import "../../global.css";

export default function Footer() {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const termsAndConditions = [
    {
      number: 1,
      title: "Tax",
      content:
        "All prices are exclusive of GST. Applicable GST will be charged additionally as per prevailing law at the time of billing.",
    },
    {
      number: 2,
      title: "Price",
      content:
        "Prices are quoted based on prevailing duties, taxes, and currency exchange rates at the time of this proposal. Any increase in applicable duties, taxes, levies, or foreign exchange rates before or during delivery shall be borne by the client and will be adjusted in the final invoice.",
    },
    {
      number: 4,
      title: "Payment terms",
      content:
        "[e.g., 40% advance, 40% on completion, 20% on deployment]. Demand Draft / Cheque /Bank Transfer in favor of INFINITI INFOTECH and the same has to be forwarded to our Tirunelveli office. Final deployment and access shall only be provided upon receipt of full payment.",
    },
    {
      number: 5,
      title: "Scope of Work",
      content:
        "This proposal covers features, modules, and services as explicitly mentioned in the quotation. Any additional features or changes requested will be treated as change requests and billed separately.",
    },
    {
      number: 6,
      title: "Hosting & Domain",
      content:
        "Hosting, domain registration, and SSL certificates will be arranged under this proposal. Renewal charges shall be billed annually in advance, and services will be suspended automatically if renewal payments are not received before the due date.",
    },
    {
      number: 7,
      title: "Support & Maintenance",
      content:
        "The first 2 months after implementation will be covered under warranty at no additional cost, limited to bug fixes and functional issues or new requirements will be billed separately. The subsequent 10 months of the first year shall be covered under an Annual Maintenance Contract (AMC) at the agreed AMC cost. From the second year onward, support and maintenance will continue under AMC renewal.",
    },
    {
      number: 8,
      title: "Ownership & Intellectual Property",
      content:
        "Source code and intellectual property rights shall remain with INFINITI INFOTECH. The client shall have rights to use the hosted software as a service. source code will not be shared.",
    },
    {
      number: 9,
      title: "Confidentiality",
      content:
        "Both parties agree to maintain confidentiality of all shared information, documents, and data during and after the project.",
    },
    {
      number: 10,
      title: "Warranty",
      content:
        "The delivered solution will be free from functional defects for a warranty period of 3 months from deployment. Any issues reported during this period will be rectified without additional cost. It excludes new requests, third-party failures, or misuse.",
    },
    {
      number: 11,
      title: "Jurisdiction",
      content: "All disputes are subject to Tirunelveli jurisdiction only.",
    },
    {
      number: 12,
      title: "Client Responsibilities",
      content:
        "The client shall provide timely inputs, approvals, and access to necessary resources required for successful completion of the project. Delays in client inputs, approvals, or credentials will extend delivery timelines without penalty to INFINITI INFOTECH.",
    },
    {
      number: 13,
      title: "Change Requests",
      content:
        "Any modification or addition to the agreed scope will be considered a change request and will attract additional cost and revised timelines.",
    },
    {
      number: 14,
      title: "Third-Party Integrations",
      content:
        "Any third-party APIs, services, or licenses required for the project shall be borne by the client, either through direct subscription or inclusion in the final invoice as mutually agreed. Furthermore, any request not explicitly included in the agreed scope—regardless of size or complexity—shall be treated as a change request, subject to additional cost and revised timelines.",
    },
    {
      number: 15,
      title: "Data Security & Backup",
      content:
        "INFINITI INFOTECH is not responsibility for periodic data backup, archival, and compliance with industry or statutory standards shall rest solely with the client, unless explicitly covered under a separate written agreement. INFINITI INFOTECH shall not be liable for any data loss, corruption, or compliance failures arising out of the client's failure to maintain such backups or standards.",
    },
    {
      number: 16,
      title: "Force Majeure",
      content:
        "INFINITI INFOTECH shall not be held liable for delays or failure in performance due to events beyond reasonable control, including natural calamities, government restrictions, or network outages.",
    },
    {
      number: 17,
      title: "Termination",
      content:
        "Either party may terminate the agreement with 30 days' written notice. Upon termination, payments for all completed work and costs incurred up to the termination date shall be payable immediately, and INFINITI INFOTECH reserves the right to suspend access to deliverables until such payments are received.",
    },
    {
      number: 18,
      title: "Limitation of Liability",
      content:
        "INFINITI INFOTECH's total liability, whether in contract, tort, or otherwise, shall be strictly limited to the total project value actually paid by the client under this agreement. Under no circumstances shall INFINITI INFOTECH be liable for any indirect, incidental, special, exemplary, or consequential damages, including but not limited to loss of profits, loss of business, loss of data, or reputational harm. This limitation of liability shall apply to the fullest extent permitted under applicable law.",
    },
    {
      number: 19,
      title: "Client Preference",
      content:
        "Free hosting platforms such as Netlify or Render help reduce costs, but they also come with certain limitations. These include restrictions on bandwidth, storage, and build minutes, which may affect performance and cause slower loading times. Uptime and reliability are not guaranteed, and there is a risk of service interruptions. Some free plans also have limitations on using custom domains or require extra setup. In addition, free hosting is not ideal for high-traffic websites, as scalability is limited and upgrades may be necessary in the future. Support is usually community-based rather than dedicated, and advanced features like server-side rendering, background jobs, or detailed analytics may not be available.",
    },
    {
      number: 20,
      title: "Risk of Unforeseen Issues",
      content:
        "In case of any unfortunate problems or failures with the free hosting service, recovery may be delayed or not guaranteed, unlike paid hosting which offers better stability and assurance.",
    },
    {
      number: 21,
      title: "Entire Agreement",
      content:
        "This quotation and subsequent Purchase Order constitute the entire agreement between both parties and supersede any prior discussions or representations.",
    },
    {
      number: 22,
      title: "Non-Refundable Advance",
      content:
        "Advance payments are non-refundable under any circumstances. 30% of the project budget.",
    },
    {
      number: 23,
      title: "Service Suspension",
      content:
        "In case of payment delays, services including hosting and access may be suspended until dues are cleared.",
    },
    {
      number: 24,
      title: "Deployment Rights",
      content:
        "Final live deployment will only occur after full and final payment is received.",
    },
    {
      number: 25,
      title: "License Limitation",
      content:
        "Client license is non-transferable and valid only for agreed users/organization.",
    },
    {
      number: 26,
      title: "Renewal of Services",
      content:
        "Domain, hosting, SSL, and third-party services must be renewed annually by the client at prevailing rates.",
    },
    {
      title : "Acknowledgement & Declaration",
      content : "I confirm that I have read all terms and conditions and accept them in my full presence of mind. I agree to follow all rules and regulations mentioned herein."
    }
  ];

  return (
    <>
      <footer className="footer-container">
        <div className="footer-content">
          <div className="footer-left">
            <h3 className="footer-title">Infiniti Infotech</h3>
            <p>
              © {new Date().getFullYear()} Infiniti Infotech. All rights
              reserved.
            </p>
          </div>
          <div className="footer-right">
            <button className="terms-btn" onClick={handleOpen} title="Click to view Terms & Conditions">
              Terms & Conditions
            </button>
          </div>
        </div>
      </footer>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: {
              xs: "92vh",
              sm: "85vh",
              md: "85vh",
            },
            borderRadius: {
              xs: "8px",
              sm: "12px",
            },
            margin: {
              xs: "5px",
              sm: "20px",
            },
            marginBottom: {
              xs: "60px",
              sm: "80px",
              md: "80px",
            },
            width: {
              xs: "calc(100% - 10px)",
              sm: "auto",
            },
            maxWidth: {
              xs: "calc(100% - 10px)",
              sm: "600px",
            },
          },
        }}
        sx={{
          "& .MuiBackdrop-root": {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
        }}
      >
        <DialogTitle
          sx={{
            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
            color: "#333",
            fontWeight: 600,
            padding: {
              xs: "0.75rem",
              sm: "1.5rem",
            },
            borderBottom: "1px solid #e0e0e0",
            fontSize: {
              xs: "0.9rem",
              sm: "1.25rem",
            },
          }}
        >
          Terms & Conditions
        </DialogTitle>
        <DialogContent
          sx={{
            padding: {
              xs: "0.75rem",
              sm: "1.5rem",
            },
            maxHeight: {
              xs: "calc(92vh - 140px)",
              sm: "calc(85vh - 180px)",
            },
            overflowY: "auto",
            backgroundColor: "#fafbfc",
            "&::-webkit-scrollbar": {
              width: "6px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#ccc",
              borderRadius: "3px",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: {
                xs: "1rem",
                sm: "1.25rem",
              },
            }}
          >
            {termsAndConditions.map((term, index) => (
              <Box
                key={index}
                sx={{
                  padding: {
                    xs: "0.625rem 0.75rem",
                    sm: "1rem 1.25rem",
                  },
                  backgroundColor: "#ffffff",
                  borderRadius: {
                    xs: "6px",
                    sm: "8px",
                  },
                  border: "1px solid #e9ecef",
                  borderLeft: {
                    xs: "3px solid #6c757d",
                    sm: "4px solid #6c757d",
                  },
                  transition: "all 0.2s ease",
                  "&:hover": {
                    borderLeftColor: "#ff6b3d",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                    transform: {
                      xs: "none",
                      sm: "translateX(2px)",
                    },
                  },
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: {
                      xs: "0.8rem",
                      sm: "0.95rem",
                    },
                    fontWeight: 600,
                    color: "#495057",
                    marginBottom: {
                      xs: "0.5rem",
                      sm: "0.75rem",
                    },
                  }}
                >
                  {term.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: {
                      xs: "0.75rem",
                      sm: "0.875rem",
                    },
                    color: "#6c757d",
                    lineHeight: {
                      xs: 1.5,
                      sm: 1.7,
                    },
                  }}
                >
                  {term.content}
                </Typography>
              </Box>
            ))}
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            padding: {
              xs: "0.75rem 1rem",
              sm: "1rem 1.5rem",
            },
            background: "#ffffff",
            borderTop: "1px solid #e0e0e0",
            flexDirection: {
              xs: "column",
              sm: "row",
            },
            gap: {
              xs: "0.5rem",
              sm: "0",
            },
          }}
        >
          <Button
            onClick={handleClose}
            variant="outlined"
            fullWidth={{
              xs: true,
              sm: false,
            }}
            sx={{
              color: "#495057",
              borderColor: "#dee2e6",
              fontWeight: 500,
              padding: {
                xs: "0.625rem 1.5rem",
                sm: "0.5rem 2rem",
              },
              borderRadius: "6px",
              fontSize: {
                xs: "0.875rem",
                sm: "1rem",
              },
              "&:hover": {
                borderColor: "#6c757d",
                backgroundColor: "#f8f9fa",
                color: "#212529",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
